
<template>
  <div>
    <a-spin class="loading" v-if="!loading"></a-spin>
    <div class="noti-heading">
      <div style="margin: 0">
        Thông báo (<span style="color: red">{{ totalUnreadNotification }}</span
        >)
      </div>
      <a @click="readAll()" style="font-size: 12px; color: #1e88e5"
        >Đánh dấu đọc tất cả</a
      >
    </div>

    <a-divider style="margin: 0" />
    <a-list item-layout="vertical" size="large" :data-source="notificationList">
      <a-empty v-if="totalCount == 0">
        <template #description>
          <!-- <span>Không có thông báo</span> -->
        </template>
      </a-empty>
      <template #renderItem="{ item }">
        <a-list-item
          key="item.title"
          :style="{ position: 'relative', padding: '10px 10px 10px 0px' }"
        >
          <a-list-item-meta :style="style">
            <template #title>
              <a>
                <b style="font-size: 12px">
                  {{ item.title }}
                </b>
              </a>
              <div
                v-if="item.read_status == 0"
                style="font-size: 10px; color: #1890ff"
              >
                <b>{{ item.ins_date }}</b>
              </div>

              <div v-else style="font-size: 10px">
                <b>{{ item.ins_date }}</b>
              </div>
            </template>
            <template #description>
              <div>
                <span style="font-size: 12px">{{ item.title }}</span>
              </div>
            </template>
            <template #avatar>
              <a-avatar
                :src="imageNotify"
                style="
                  height: 24px;
                  width: 24px;
                  border-radius: 50%;
                  background-color: #11509b;
                "
                alt=""
              />
            </template>
          </a-list-item-meta>
          {{ item.content }}
          <a-badge
            v-if="item.read_status == 0"
            status="processing"
            style="margin-left: 4px; position: absolute; right: -14px; top: 50%"
          />
          <a-badge
            v-else
            status="default"
            style="margin-left: 4px; position: absolute; right: -14px; top: 50%"
          />
        </a-list-item>
      </template>
    </a-list>
  </div>
</template>
<script>
import axios from "axios";
import OrderTracking from "@/pages/OrderCustomer/OrderTracking";
// import EventBus from "@/event-bus";

export default {
  components: {
    OrderTracking,
  },
  data() {
    return {
      imageNotify: require("@/assets/img/petrolimex_logo.webp"),
      notificationList: [],
      orderTracking: {},
      orderSelected: {},
      pageIndex: 1,
      isLoadingNotification: false,
      loading: false,
      isViewUnRead: true,
      isLoadAll: false,
      totalCount: 0,
      totalUnreadNotification: 0,
      style: {
        padding: "39px 16px 52px 16px",
      },
    };
  },
  created() {
    this.loadNotification(this.pageIndex);
  },
  methods: {
    tabChange() {
      this.isViewUnRead = !this.isViewUnRead;
      this.pageIndex = 1;
      this.notificationList = [];
      this.loadNotification(this.pageIndex);
    },
    onScrollNotification({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      if (
        !this.isLoadAll &&
        scrollTop + clientHeight >= scrollHeight &&
        !this.isLoadingNotification
      ) {
        this.loadNotification(++this.pageIndex);
      }
    },
    loadNotification(pageIndex) {
      if (!this.isLoadingNotification) {
        this.isLoadingNotification = true;
        axios
          .get(`c-notification/list`, {
            params: {
              pageIndex,
              isViewUnRead: this.isViewUnRead,
            },
          })
          .then((response) => {
            // this.countNotification = response.data.countUnread;
            this.notificationList = this.notificationList.concat(
              response.data.notification
            );
            this.totalCount = +response.data.count;
            this.totalUnreadNotification = response.data.countUnread;
            this.isLoadAll =
              this.notificationList.length >= response.data.count;
          })
          .catch((error) => {})
          .finally(() => {
            this.isLoadingNotification = false;
            this.loading = true;
          });
      }
    },
    readAll() {
      axios
        .get(`c-notification/read`)
        .then((response) => {})
        .catch((error) => {})
        .finally(() => {});
    },
    getOrderHistory(id, orderId, notiItem) {
      axios
        .get("c-order/tracking?id=" + orderId)
        .then((response) => {
          this.$refs.form_tracking.openNav();
          this.orderTracking = response.data;
          this.orderSelected = response.data.order;
          this.updateNotificationLog(id);
          if (notiItem.read_status === 0) {
            // EventBus.$emit("read-notification", id);
          }
          notiItem.read_status = 1;
        })
        .catch((error) => {});
    },
    updateNotificationLog(id) {
      axios
        .post("c-notification/save", {
          id: id,
        })
        .then((response) => {
          this.loadNotification();
        })
        .catch((error) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.noti-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: 0px;
  width: 100%;
  border-top: 1px solid rgb(232, 232, 232);
  padding: 8px 12px;
  text-align: right;
  left: 0px;
  background: rgb(255, 255, 255);
  z-index: 10;
}
.loading {
  text-align: center;
  width: 100%;
}
</style>
